import * as _ from 'underscore';

import { Module } from '../Module';

// Don't update the location to the error state.
// The error state doesn't provide a url and this causes the router to fall back to the user's start page.
export const DefaultErrorStateOptions = { location: false };

/**
 * Use this class to transition to the error state. Wraps all calls to main.error to use location: false so that
 * ui-router doesn't attempt to update the url.
 */
export class ErrorState {

  public static $inject = ['$state'];

  constructor(private $state: angular.ui.IStateService) { }

  public go(params = {}, options: angular.ui.IStateOptions = {}): angular.IPromise<any> {
    _.defaults(options, DefaultErrorStateOptions);
    return this.$state.go('main.error', params, options);
  }

}

Module.instance().service('ErrorState', ErrorState);
